import {Alert, Box, CircularProgress} from "@mui/material";
import React, {useEffect} from "react";
import {useAuth} from "react-oidc-context";
import {useNavigate} from "react-router-dom";

interface AuthState {
	returnTo?: string;
}

export function AuthCallback() {
	const auth = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		if (auth.isLoading) return;
		if (auth.isAuthenticated) {
			const state = auth.user?.state as AuthState | undefined;
			const returnTo = state?.returnTo && state.returnTo.startsWith("/") ? state.returnTo : "/";
			navigate(returnTo, {replace: true});
			return;
		}
		if (!auth.error) {
			// Token exchange settled but produced neither a user nor an error — avoid stranding the user on the spinner.
			navigate("/", {replace: true});
		}
	}, [auth.isAuthenticated, auth.isLoading, auth.error, auth.user, navigate]);

	if (auth.error) {
		return (
			<Box p={4}>
				<Alert severity="error">Authentication failed: {auth.error.message}</Alert>
			</Box>
		);
	}

	return (
		<Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
			<CircularProgress />
		</Box>
	);
}
